import React from "react";
import { MenuItem, useDisclosure } from "@chakra-ui/react";
import { getUserTimezone, useAuth } from "duck";
import { useExportClientReportMutation } from "requests";
import Modal from "../../../../../modal";

interface ClientReportProps {
  caseId: number;
  handleClose(): void;
}

const ClientReport: React.FC<ClientReportProps> = ({ caseId, handleClose }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [exportReport] = useExportClientReportMutation();
  const [{ user }] = useAuth();

  const exportOnEmail = (recipientEmail: string) =>
    exportReport({
      variables: {
        input: {
          medicalCase: caseId,
          recipientEmail,
          userTimezone: getUserTimezone()
        }
      }
    });

  return (
    <>
      <MenuItem onClick={onOpen} fontSize="sm">
        Client report
      </MenuItem>

      <Modal.Export
        isOpen={isOpen}
        onClose={() => {
          onClose();
          handleClose();
        }}
        title="Case Export"
        description="Please provide the email address to which you want to export the case data."
        onExport={exportOnEmail}
        defaultValue={user?.email}
      />
    </>
  );
};

export default ClientReport;
